
import React, { useState } from 'react'
import { Button, Grid } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import DoneIcon from '@mui/icons-material/Done'
import ReplayIcon from '@mui/icons-material/Replay'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import UploadIcon from '@mui/icons-material/Upload'
import ConfirmModal from '../../../../../../../components/ConfirmModal'
import useAxios, { axiosInstance } from '../../../../../../../hooks/useAxios'
import { EOrderStatus } from '../../../../../../../types/order'

import PrintIcon from '@mui/icons-material/Print';

export interface IOrderMenuSelect {
  isPrint?: boolean,
  isReturn?: boolean,
  onClick: (status: EOrderStatus) => void
  total?: number
}

export const OrderMenuSelect = (props: IOrderMenuSelect) => {
  const { isPrint,isReturn, onClick, total } = props
  const [isConfirmModal, setIsConfirmModal] = useState<boolean>(false)
  const [status, setStatus] = useState<EOrderStatus>()
  const handleConfirm = () => {
    setIsConfirmModal(false)
    onClick(status as EOrderStatus)
  }

  return (<>
    <ConfirmModal
      open={isConfirmModal}
      onClose={() => setIsConfirmModal(false)}
      onConfirm={handleConfirm}
      title={"ยืนยันการเปลี่ยนสถานะ"}
      message={"คุณต้องการปริ้นรายการนี้หรือไม่?"}
    />
    <Grid container spacing={2} mb={2}>
      {isPrint && <Grid item>
        <Button variant="contained" size="medium" startIcon={<PrintIcon />} color={'warning'}
          onClick={() => {
            setStatus(EOrderStatus.PENDING)
            setIsConfirmModal(true)
          }}
        >
          พิมพ์ใบปะหน้า {`(${total})`}
        </Button>
      </Grid>}
      {isReturn && <Grid item>
        <Button variant="contained" size="medium" startIcon={<ReplayIcon />} color={'info'}
          onClick={() => {
            setStatus(EOrderStatus.RETURN)
            setIsConfirmModal(true)
          }}
        >
          ตีกลับ(รับสินค้าแล้ว)
        </Button>
      </Grid>}
    </Grid>
  </>)
}